//import { HandIcon } from './HandIcon';

export const Logo = ({ 
  size = 'md',
  className = ""
}) => {
  const sizes = {
    sm: { icon: 18, fontSize: '24px', gap: '0px' },
    md: { icon: 24, fontSize: '34px', gap: '0px' },
    lg: { icon: 27, fontSize: '40px', gap: '0px' },  // 아이콘 작게: 38 → 30
    xl: { icon: 42, fontSize: '48px', gap: '0px' }
  };

  const currentSize = sizes[size] || sizes.md;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: currentSize.gap
    }} className={className}>
      {/* <HandIcon 
        size={currentSize.icon} 
        color="#2C3E50"
      /> */}
  <span style={{
  fontWeight: '700',
  fontStyle: 'italic',
  fontSize: currentSize.fontSize,
  color: '#2C3E50',
  letterSpacing: '-1px'
}}>
  PickFlip
</span>
    </div>
  );
};